import { render, staticRenderFns } from "./bottompc.vue?vue&type=template&id=e08a2d74&scoped=true"
import script from "./bottompc.vue?vue&type=script&lang=js"
export * from "./bottompc.vue?vue&type=script&lang=js"
import style0 from "./bottompc.vue?vue&type=style&index=0&id=e08a2d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a2d74",
  null
  
)

export default component.exports